export const validateRules = (formData) => {

    const {houseRules} = formData
    const errors = [];
  
    if (!houseRules) {
      errors.push({
        error: "House rules field is required",
        errorType: 'houseRules'
      })
      return { errors, isValid: false };
    }
  
  
    if (houseRules.length === 0) {
      errors.push({
        error: "No house rules have been added",
        errorType: 'houseRules'
      })
      return { errors, isValid: false };
    }
  
    return {
      errors,
      isValid: Object.keys(errors).length === 0,
    };
  };